var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { isHTML } from "./edit";
/** <b>Composant en mode consultation/detail d'un champ de type base</b>*/
export default function BaseFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, link = _a.link, fieldMetadata = _a.fieldMetadata, target = _a.target, className = _a.className;
    var HtmlToText = function (htmlContent) {
        return (_jsx("div", { className: "html-text", dangerouslySetInnerHTML: { __html: htmlContent } }));
    };
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    return (_jsx("span", __assign({ className: "flex items-center ".concat(className ? className : "") }, { children: link ? (_jsx("a", __assign({ href: value, target: target, rel: "noopener noreferrer", className: "text-[rgb(var(--color-blue-400))] hover:text-blue-400" }, { children: value }))) : isHTML(value) ? (_jsx("p", { children: HtmlToText(value) })) : (_jsx("span", __assign({ className: "" }, { children: value }))) })));
}
